import { queryAll, query, fromId } from '../utils/utils.js';

export class StickyHeroNav {

    htmlBlock = null;
	heroBlock = null;
    heroBlockMin = null;
    heroBlockMax = null;
    heroBlockBackground = null;
    navSet = null;
    interiorNavBlock = null;
    interiorNavGroup = null; // nav group containing hero and nav in one
    interiorNavMobile = null;
    prevScrollpos = document.body.scrollTop || document.documentElement.scrollTop;
    isCollapsed = false;
    canCollapse = true;
	origHeight = null;
    navDist = 0;
	hasHero = true;

    constructor() {
		this.htmlBlock = query('html');
        this.heroBlock = query('.entry-content > .detail-hero, .entry-content > .variation-basic');
        this.interiorNavBlock = query('.entry-content > .interior-nav-block');

        let hasStickyHeroNav = false;

		if( this.heroBlock !== null && this.interiorNavBlock !== null
            && this.interiorNavBlock.previousElementSibling !== null
            && query('.entry-content').firstElementChild == this.heroBlock
            && this.interiorNavBlock.previousElementSibling == this.heroBlock ){
            hasStickyHeroNav = true;
            this.initStickyHeroNav();

		} else {
            console.log( "[bhs] no hero block or interior nav block found" );
			if(this.interiorNavBlock !== null){
				//account for not having a hero block but still having an interior nav block
				this.interiorNavBlock.classList.add('is-sticky-with-no-hero');
				// this.interiorNavBlock.classList.add('is-sticky');
				this.hasHero = false;
				this.initStandaloneStickyNav();
			}
        }

        /**
         * Remove the detail min if no interior nav is present and the hero block is not sticky
         */
        if (!hasStickyHeroNav && (this.heroBlock !== null && this.interiorNavBlock === null)) {
            if ( this.heroBlock.querySelector('.detail-min') ) {
                this.heroBlock.querySelector('.detail-min').remove();

                this.heroBlock.classList.add('no-min');
            }
        }
    }

    initStickyHeroNav() {
		try{
			console.log( "[bhs] init sticky hero nav ");

			// reset the top padding of the wp-site-blocks //
			if( query('.wp-site-blocks') ) query('.wp-site-blocks').classList.add('has-sticky-hero-nav');
			if (query('.entry-content')) query('.entry-content').classList.add('has-sticky-hero-nav');

			this.heroBlock.classList.add('is-grouped-with-nav');
			this.origHeight = this.heroBlock.getBoundingClientRect().height;
			this.heroBlockMin = this.heroBlock.querySelector('.detail-min');
			this.heroBlockMax = this.heroBlock.querySelector('.detail-max');
			this.heroBlockBackground = this.heroBlock.querySelector('.background');
			this.interiorNavGroup = this.interiorNavBlock.querySelector('.interior-nav-group');
			this.interiorNavMobile = this.interiorNavBlock.querySelector('.interior-nav-mobile');
			this.navSet = this.interiorNavBlock.querySelector('.nav-set');
			this.navDist = this.heroBlockMax.getBoundingClientRect().top + this.heroBlockMax.getBoundingClientRect().height + this.navSet.getBoundingClientRect().top;

			const interiorNav = this.interiorNavBlock.querySelector('.interior-nav');

			const rowDiv = this.interiorNavBlock.querySelector('.nav-content');
			rowDiv.appendChild( this.heroBlock );

			this.interiorNavBlock.classList.add('has-hero');
			this.interiorNavBlock.classList.add('is-sticky');
			this.interiorNavGroup.classList.add('handle-hide-nav');

			// const minContentBB = this.heroBlockMin.getBoundingClientRect();
			// const maxContentBB = this.heroBlockMax.getBoundingClientRect();
			// const navSetBB = this.navSet.getBoundingClientRect();

			// let maxStyle = window.getComputedStyle(this.heroBlock);
			// let bottomPadding = ['padding-bottom', 'margin-bottom']
			//     .map((key) => parseInt(maxStyle.getPropertyValue(key), 10))
			//     .reduce((prev, cur) => prev + cur);

			// this.interiorNavGroup.minHeight = this.interiorNavGroup.dataset.minHeight = ((170 + minContentBB.height + bottomPadding + navSetBB.height));
			// this.interiorNavGroup.maxHeight = this.interiorNavGroup.dataset.maxHeight = (228 + maxContentBB.height + bottomPadding + navSetBB.height);

			//leave this to handleScroll
			// const heroBlockPaddingT = parseInt(window.getComputedStyle(this.heroBlock).paddingTop);
			// const heroBlockPaddingB = parseInt(window.getComputedStyle(this.heroBlock).paddingBottom);
			// const heroBlockPadding = heroBlockPaddingT + heroBlockPaddingB;
			// this.heroBlock.style.height = this.heroBlockMax.getBoundingClientRect().height + heroBlockPadding + 'px';
			// console.log(this.heroBlockMax.getBoundingClientRect().height);

			window.addEventListener('scroll', (e) => {
				this.handleScroll();
			});

			window.addEventListener('resize', (e) => {
				this.handleResize();
			});


			setTimeout( ()=>{
				this.handleResize();
				this.handleScroll();
			} , 150 );
		}catch(e){
			console.log(e);
		}

    }


    initStandaloneStickyNav() {
		try{
			console.log( "[bhs] init standalone sticky hero nav ");

			const interiorNav = this.interiorNavBlock.querySelector('.interior-nav');
			this.interiorNavGroup = this.interiorNavBlock.querySelector('.interior-nav-group');
			this.heroBlock = this.interiorNavBlock;
			this.heroBlockMin = this.interiorNavBlock;
			this.heroBlockMax = this.interiorNavBlock;
			this.interiorNavMobile = this.interiorNavBlock.querySelector('.interior-nav-mobile');
			this.navSet = this.interiorNavBlock.querySelector('.nav-set');
			this.navDist = this.heroBlockMax.getBoundingClientRect().top + this.heroBlockMax.getBoundingClientRect().height + this.navSet.getBoundingClientRect().top;

			let mobileStatus = document.createElement('div');
			mobileStatus.innerHTML = '<button class="anchor-nav-trigger" class="d-md-none"><span class="title"></span><i class="icon icon-arrow-down"></i></button>';

			this.interiorNavGroup.appendChild(mobileStatus);
			this.interiorNavBlock.classList.add('has-hero');
			this.interiorNavBlock.classList.add('is-sticky');

			window.addEventListener('scroll', (e) => {
				this.handleScroll();
			});

			window.addEventListener('resize', (e) => {
				this.handleResize();
			});


			setTimeout( ()=>{
				this.handleResize();
				this.handleScroll();
			} , 150 );
		}catch(e){
			console.log(e);
		}

    }


    handleScroll() {
        const currentScrollPos = document.body.scrollTop || document.documentElement.scrollTop;
        const threshold = 10;

        let interiorNavHeight = 0;

        if (currentScrollPos > threshold) {
            if (!this.isCollapsed) {
                this.isCollapsed = true;
				this.htmlBlock.classList.add('has-scrolled-internal-nav');
				this.heroBlock.classList.add('has-scrolled');
				this.interiorNavGroup.classList.add('has-scrolled');
				this.heroBlockMin.classList.add('has-scrolled');
				this.heroBlockMax.classList.add('has-scrolled');
				interiorNavHeight = this.interiorNavGroup.minHeight;
            }
        } else {
            if (this.isCollapsed) {
                this.isCollapsed = false;
				this.htmlBlock.classList.remove('has-scrolled-internal-nav');
				this.heroBlock.classList.remove('has-scrolled');
				this.interiorNavGroup.classList.remove('has-scrolled');
				this.heroBlockMax.classList.remove('has-scrolled');
				this.heroBlockMin.classList.remove('has-scrolled');
				interiorNavHeight = this.interiorNavGroup.maxHeight;

				if (this.interiorNavBlock.querySelector('.interior-nav-mobile') ) {

					const mobileIntTrigger = this.interiorNavBlock.querySelector('button.anchor-nav-trigger');

					if( mobileIntTrigger ) mobileIntTrigger.classList.remove('active');

					this.interiorNavMobile.style.height = "0px";
				}
            }
        }

        if ( interiorNavHeight > 0 ) {
            this.interiorNavGroup.style.height = interiorNavHeight + 'px';
        }

        this.prevScrollpos = currentScrollPos;
    }

    handleResize() {
		if(this.hasHero){
			this.heroBlockMin.style.width = this.heroBlockMax.getBoundingClientRect().width + 'px';
		}
        const minContentBB = this.heroBlockMin.getBoundingClientRect();
        const maxContentBB = this.heroBlockMax.getBoundingClientRect();
        const navSetBB = this.navSet.getBoundingClientRect();

        let maxStyle = window.getComputedStyle(this.heroBlock);
        let bottomPadding = ['padding-bottom', 'margin-bottom']
            .map((key) => parseInt(maxStyle.getPropertyValue(key), 10))
            .reduce((prev, cur) => prev + cur);
		if(bottomPadding <= 20){
			bottomPadding = 40;
		}
        // console.log("is mobile: "+ this.detectMobile());

        if( !this.detectMobile() ) {
			if(this.hasHero){
				this.interiorNavGroup.minHeight = this.interiorNavGroup.dataset.minHeight = ((170 + minContentBB.height + bottomPadding + navSetBB.height));
				this.interiorNavGroup.maxHeight = this.interiorNavGroup.dataset.maxHeight = (228 + maxContentBB.height + bottomPadding + navSetBB.height);
			}else{
				this.interiorNavGroup.minHeight = this.interiorNavGroup.dataset.minHeight = 200;
				this.interiorNavGroup.maxHeight = this.interiorNavGroup.dataset.maxHeight = 60;
			}
        } else {
			if(this.hasHero){
            	this.interiorNavGroup.minHeight = this.interiorNavGroup.dataset.minHeight = ((70 + minContentBB.height + bottomPadding ));
            	this.interiorNavGroup.maxHeight = this.interiorNavGroup.dataset.maxHeight = (100 + maxContentBB.height + bottomPadding );
			}else{
				this.interiorNavGroup.minHeight = this.interiorNavGroup.dataset.minHeight = 130;
				this.interiorNavGroup.maxHeight = this.interiorNavGroup.dataset.maxHeight = 60;
			}
        }

        if (this.isCollapsed) {
            this.interiorNavGroup.style.height = this.interiorNavGroup.minHeight + 'px';
        } else {
            this.interiorNavGroup.style.height = this.interiorNavGroup.maxHeight + 'px';
        }

        if (this.interiorNavBlock.querySelector('.interior-nav-mobile')) {

            const mobileIntTrigger = this.interiorNavBlock.querySelector('button.anchor-nav-trigger');
            if (mobileIntTrigger) mobileIntTrigger.classList.remove('active');

            this.interiorNavMobile.style.height = "0px";
        }
    }

    detectMobile() {
        const mobileDiv = query('.navbar .is-mobile');

        if (mobileDiv) {
            const display = window.getComputedStyle(mobileDiv).display;

            if (display === 'block') return true;
        }

        return false;
    }

}
